import http from '@/core/http'
import { last, map, filter, size } from 'lodash'

const url = 'afiliados-contratos'
const urlComission = 'afiliados-comissoes'
const urlRegionProducts = 'region-products'

const state = {
  itens: [],
  products: [
    {
      productName: 'DEFAULT',
      showProduct: true,
      regionProductId: null,
      comissionTypeId: null,
      maxRange: 0,
      minRange: 0,
      aliquot: 0,
      listRange: []
    }
  ],
  contractTypes: [],
  comissionTypes: [],
  conditionTypes: [],
  itemValueRange: {
    minRange: 0,
    maxRange: 0,
    aliquot: 0
  },
  listValues: [],
  item: {
    id: null,
    name: '',
    contractTypeId: '',
    comissionTypeId: '',
    entityRegionId: '',
    ngrComposition: '',
    jsonConfig: {},
  },
  itemCassino: {
    itemValueRange: {
      minRange: 0,
      maxRange: 0,
      aliquot: 0
    },
    listValues: [],
  },
  itemProg: {
    id: null,
    name: '',
    contractTypeId: '',
    comissionTypeId: '',
    entityRegionId: '',
    ngrComposition: '',
    jsonConfig: {},
    itemValueRange: {
      minRange: 0,
      maxRange: 0,
      aliquot: 0
    },
    listValues: [],
  },
  listOperator: [],
  itemOperator: {
    type: '',
    condition: '',
    value: 0
  },
  totalItens: 0,
  totalTypes: 0,
  totalItemSelect: 0,
  totalComissionTypes: 0,

  /* Pagamentos */
  listPagamentos: [],
  itemPagamentos: {
    start: 1,
    end: '-',
    value: ''
  },
  totalPagamentos: 0,
}

const headers = { moduloname: 'afiliados' }

const actions = {
  /* Pagamentos */
  addPagamentos: ({ commit }, payload) => {
    const obj = Object.assign({}, payload)
    commit('ADD_PAGAMENTOS', obj)
    return Promise.resolve(true)
  },

  deletePagamentos: ({ commit }, payload) => {
    commit('DELETE_PAGAMENTOS', payload)
    return Promise.resolve(true)
  },

  clearPagamentos: ({ commit }, payload) => {
    commit('CLEAR_PAGAMENTOS', payload)
    return Promise.resolve(true)
  },

  incrementPagamentos: ({ commit, state }) => {
    if (!size(state.listPagamentos)) return
    commit('INCREMENT_PAGAMENTOS')
    return Promise.resolve(true)
  },

  addTypeOperators: ({ commit }, payload) => {
    commit('ADD_TYPE_OPERATOR', payload)
    return Promise.resolve(true)
  },

  deleteTypeOperator: ({ commit }, payload) => {
    commit('DELETE_TYPE_OPERATOR', payload)
    return Promise.resolve(true)
  },

  clearTypeOperator: ({ commit }, payload) => {
    commit('CLEAR_TYPE_OPERATOR', payload)
    return Promise.resolve(true)
  },

  /* range values */
  addRangeValues: ({ commit }, payload) => {
    commit('ADD_VALUE_RANGE', payload)
    return Promise.resolve(true)
  },
  addRangeValuesCassino: ({ commit }, payload) => {
    commit('ADD_VALUE_RANGE_CASSINO', payload)
    return Promise.resolve(true)
  },
  addRangeValuesProg: ({ commit }, payload) => {
    commit('ADD_VALUE_RANGE_PROG', payload)
    return Promise.resolve(true)
  },

  editValuesRange: ({ commit }, payload) => {
    commit('EDIT_VALUE_RANGE', payload)
    return Promise.resolve(true)
  },

  deleteValueRange: ({ commit }, payload) => {
    commit('DELETE_VALUE_RANGE', payload)
    return Promise.resolve(true)
  },

  deleteValueRangeCassino: ({ commit }, payload) => {
    commit('DELETE_VALUE_RANGE_CASSINO', payload)
    return Promise.resolve(true)
  },

  deleteValueRangeProg: ({ commit }, payload) => {
    commit('DELETE_VALUE_RANGE_PROG', payload)
    return Promise.resolve(true)
  },

  clearValueRange: ({ commit }, payload) => {
    commit('CLEAR_VALUE_RANGE', payload)
    return Promise.resolve(true)
  },
  clearValueRangeCassino: ({ commit }, payload) => {
    commit('CLEAR_VALUE_RANGE_CASSINO', payload)
    return Promise.resolve(true)
  },
  clearValueRangeProg: ({ commit }, payload) => {
    commit('CLEAR_VALUE_RANGE_PROG', payload)
    return Promise.resolve(true)
  },

  incrementValueRange: ({ commit }) => {
    commit('INCREMENT_VALUE_RANGE')
    return Promise.resolve(true)
  },

  getTypesContrato: async ({ commit }, payload) => {
    const result = await http.get(`${url}/types`, { params: { ...payload }, headers })
    commit('LISTA_TYPES_CONTRACT', result.data)
    return Promise.resolve(result)
  },

  getTypesCondicoes: async ({ commit }, payload) => {
    const result = await http.get(`/afiliados-condicoes/types`, { params: { ...payload }, headers })
    commit('LIST_CONDITIONS_TYPES', result.data)
    return Promise.resolve(result)
  },

  getComissions: async ({ commit }, payload) => {
    const result = await http.get(`${urlComission}`, { params: { ...payload }, headers })
    commit('LISTA_TYPES_COMISSION', result.data)
    return Promise.resolve(result)
  },

  getItens: async ({ commit }, payload) => {
    const result = await http.get(url, { params: { ...payload }, headers })
    commit('LISTA_ITENS', result.data)
    return Promise.resolve(result)
  },

  cadastrarItem: async (_, payload) => {
    const result = await http.post(url, payload)
    return Promise.resolve(result)
  },

  editarItem: async (_, payload) => {
    const result = await http.put(url, payload)
    return Promise.resolve(result)
  },

  deletarItem: async (_, payload) => {
    const result = await http.delete(url, { params: payload })
    return Promise.resolve(result)
  },

  getItem: async ({ commit, getters }, payload) => {
    const result = await http.get(url, { params: { _addlFilter: { 'ContractsAffiliate:id_=': payload.id } } })
    commit('LISTA_ITEM', { payload: result, getters })
    Promise.resolve(result)
  },

  /* Modal Cadsatro Actions start */

  getProducts: async ({ commit }, payload) => {
    const result = await http.get(urlRegionProducts, payload)
    commit('DEFINE_PRODUCTS', result.data.resultMap)
    Promise.resolve(result)
  },

  getProduct: async ({ commit }, payload) => {
    const result = await http.get(url, { params: { _addlFilter: { 'ContractsAffiliate:id_=': payload.id } } })
    commit('DEFINE_PRODUCT', payload)
    Promise.resolve(result)
  },

  /* Modal Cadsatro Actions end*/

  limparItem: ({ commit }) => {
    commit('LIMPAR_ITEM')
  },

  clearModal: ({ commit }) => {
    commit('CLEAR_ITENS')
  }
}

const mutations = {
  'ADD_TYPE_OPERATOR'(state, payload) {
    if (payload.edit) {
      state.listOperator[payload.edit] = payload
      return Promise.resolve(true)
    }
    state.listOperator.push(Object.assign({}, payload))
    return Promise.resolve(true)
  },

  'DELETE_TYPE_OPERATOR'(state, payload) {
    const filtro = state.listOperator.filter((v, k) => k !== payload)
    state.listOperator = filtro
  },
  'CLEAR_TYPE_OPERATOR'(state) {
    state.itemOperator = {
      type: '',
      condition: '',
      value: 0
    }
  },
  /* Pagamentos */
  'ADD_PAGAMENTOS'(state, payload) {
    state.listPagamentos.push(Object.assign({}, payload))
    return Promise.resolve(payload)
  },

  'DELETE_PAGAMENTOS'(state, payload) {
    const filtro = state.listPagamentos.filter((v, k) => k !== payload)
    state.listPagamentos = filtro
  },
  'INCREMENT_PAGAMENTOS'(state) {
    const item = last(state.listPagamentos)
    state.itemPagamentos = {
      minRange: item.maxRange,
      maxRange: item.maxRange + 1,
      value: 0,
      comissionTypeId: item.comissionTypeId
    }
  },
  'CLEAR_PAGAMENTOS'(state) {
    const item = last(state.listPagamentos)
    if (size(item)) {
      state.itemPagamentos = Object.assign({}, {
        minRange: '',
        maxRange: '',
        value: 0,
        comissionTypeId: item.comissionTypeId
      })
    } else {

      state.itemPagamentos = {
        minRange: '',
        maxRange: '',
        value: 0,
        comissionTypeId: ''
      }
    }

  },

  /* Values ranges */
  'ADD_VALUE_RANGE'(state, payload) {
    if (payload.edit) {
      state.listValues[payload.edit] = payload
      return Promise.resolve(true)
    }
    state.listValues.push(Object.assign({}, payload))
  },

  'EDIT_VALUE_RANGE'(state, payload) {
    state.itemValueRange = state.listValues[payload]
    state.itemValueRange.edit = payload
  },

  'DELETE_VALUE_RANGE'(state, payload) {
    const filtro = state.listValues.filter((v, k) => k !== payload)
    state.listValues = filtro
  },

  'DELETE_VALUE_RANGE_CASSINO'(state, payload) {
    const filtro = state.itemCassino.listValues.filter((v, k) => k !== payload)
    state.itemCassino.listValues = filtro
  },

  'DELETE_VALUE_RANGE_PROG'(state, payload) {
    const filtro = state.itemProg.listValues.filter((v, k) => k !== payload)
    state.itemProg.listValues = filtro
  },

  'INCREMENT_VALUE_RANGE'(state) {
    const item = last(state.listValues)
    if (item) {
      state.itemValueRange = {
        minRange: item.maxRange,
        maxRange: item.maxRange + 1,
        aliquot: 0
      }
    }
  },

  'CLEAR_VALUE_RANGE'(state) {
    state.itemValueRange = {
      minRange: 0,
      maxRange: '',
      aliquot: ''
  }
},

  'CLEAR_VALUE_RANGE_PROG' (state) {
      state.itemProg.itemValueRange = {
        minRange: '',
        maxRange: '',
        aliquot: ''
    }
  },
  'LIST_CONDITIONS_TYPES'(state, payload) {
    state.conditionTypes = payload.resultMap
  },

  'LISTA_TYPES_CONTRACT'(state, payload) {
    state.contractTypes = payload.resultMap
    state.totalTypes = payload.totalItens
  },

  'LISTA_TYPES_COMISSION'(state, payload) {
    state.comissionTypes = payload.resultMap
    state.itemCassino.comissionTypeId = payload.resultMap
    state.itemProg.comissionTypeId = payload.resultMap
    state.totalComissionTypes = payload.totalItens
  },

  'EDIT_ITEM_TYPE_CONTRACT'(state, payload) {
    state.itemTypeContract = payload
  },

  'CLEAR_ITEM_TYPE_CONTRACT'(state) {
    state.itemTypeContract = { name: '', description: '' }
  },

  'LISTA_ITENS'(state, payload) {
    state.itens = payload.resultMap
    state.totalItens = payload.totalItens
  },

  'LISTA_ITEM'(state, { payload, getters }) {
    state.item = payload.data.resultMap[0]

    const dados = payload.data.resultMap[0]
    if (dados && dados.conditions) {
      state.listOperator = payload.data.resultMap[0].conditions || []
    }

    if (dados && dados.contractRangeValues) {
      state.listValues = payload.data.resultMap[0].contractRangeValues || []

      // inpede editar o tipo de contrato dentro de Receitas.
      if (state.item.contractRangeValues[0]) state.item.comissionTypeId = getters.listTipeSelectComissionFilter(false, state.item.contractRangeValues[0].comissionTypeId)[0]
      if (payload.data.resultMap[0].contractTypeId === 'CPA') {
        state.listPagamentos = payload.data.resultMap[0].contractRangeValues || []
      }
    }
  },

  'LIMPAR_ITEM'(state) {
    state.item = {
      contractTypeId: '',
      comissionTypeId: '',
      entityRegionId: '',
      ngrComposition: '',
      jsonConfig: {},
    }
  },

  'CLEAR_ITENS'(state) {
    state.totalItens = 0
    state.listOperator = []
    state.listPagamentos = []
    state.listValues = []
    state.itemOperator = {
      type: '',
      condition: '',
      value: 0
    }
  },

  'DEFINE_PRODUCTS'(state, payload) {
    state.products = []

    state.products.push({
      productName: 'DEFAULT',
      regionProductId: null,
      comissionTypeId: null,
      maxRange: 0,
      minRange: 0,
      aliquot: 10,
      listRange: [],
      showProduct: true,
    })
    state.products.push(...payload.map((p) => ({
      productName: p.regionProductTypes.name,
      regionProductId: p.id,
      comissionTypeId: null,
      maxRange: 0,
      minRange: 0,
      aliquot: 0,
      listRange: [],
      showProduct: false
    })))
  },

  'DEFINE_PRODUCT'(state, payload) {
    // remover 999999999 do maxRange
    payload.regionProducts.forEach(product => {
      product.contractRangeValues = product.contractRangeValues.filter(range => range.maxRange !== "9999999999")
    })

    let defaultProductIndex = state.products.findIndex(product => product.productName === 'DEFAULT')

    // Atualizar state.products com base em payload.regionProducts
    state.products.forEach(product => {
      const matchedProduct = payload.regionProducts.find(p => p.id === product.regionProductId);
      if (matchedProduct) {
        // Atualizar os valores de product com base em matchedProduct
        product.productName = matchedProduct.regionProductTypes[0].name;
        product.comissionTypeId = matchedProduct.contractRangeValues[0].comissionTypeId;
        product.listRange = matchedProduct.contractRangeValues;
      } else if (payload.regionProducts.length <= 0 && !payload.contractRangeValues.regionProductId) {
        // Salvar o produto DEFAULT dentro de products
        if (defaultProductIndex !== -1 && product.productName === 'DEFAULT') {
          product.comissionTypeId = payload.contractRangeValues[0].comissionTypeId;
          product.listRange = payload.contractRangeValues;
        }
      }
    })
  }
}

const getters = {
  listaItens: state => state.itens,
  totalItens: (state) => state.totalItens,
  totalItemSelect: (state) => state.totalItemSelect,
  item: state => state.item,
  itemCassino: state => state.itemCassino,
  itemProg: state => state.itemProg,
  itemValueRange: state => state.itemValueRange,
  itemOperator: state => state.itemOperator,
  itemView: state => state.itemView,
  listaTypesContract: state => state.contractTypes || 0,
  listComissionTypes: state => state.comissionTypes || 0,

  // Getters Modal Cadastro
  products: state => state.products,

  listTipeSelectContrato: state => map(state.contractTypes, v => ({ text: `(${v.id}) ${v.name}`, value: v.id })),
  listTipeSelectComission: state => map(state.comissionTypes, v => ({ text: `(${v.id}) ${v.name}`, value: v.id, ...v })),
  listTipeSelectComissionFilter: (state, getters) => (name = false, id = false) => {
    if (name) return filter(getters.listTipeSelectComission, v => v.contractTypeId === name)
    if (id) return filter(getters.listTipeSelectComission, v => v.id === id)
  },

  listaConditions: state => map(state.conditionTypes, v => ({ text: `(${v.id}) ${v.name}`, value: v.id })),
  getConditionsName: (state, getters) => (name) => filter(getters.listaConditions, v => v.value === name),

  totalcontractTypes: state => state.totalTypes || 0,
  itemTypeContract: state => state.itemTypeContract,
  listLancamentoRangeValores: state => state.listValues,
  listLancamentoRangeValoresCassino: state => state.itemCassino.listValues,
  listLancamentoRangeValoresProg: state => state.itemProg.listValues,
  getTypeComissionTooltip: (state, getters) => (name) => filter(getters.listTipeSelectComission, v => v.contractTypeId === name),

  /* type operacao contrato */
  listTypeSelectOperators: () => {
    return [
      { text: 'Igual  =', value: '=' },
      { text: 'Maior  >', value: '>' },
      { text: 'Menor  <', value: '<' },
      { text: 'Maior e igual  >=', value: '>=' },
      { text: 'Menor e igual  <=', value: '<=' }
    ]
  },

  listOperatorContract: state => state.listOperator,

  /* PAGAMENTOS */
  itemPagamentos: state => state.itemPagamentos,
  listPagamentos: state => state.listPagamentos
}

export default { namespaced: true, state, actions, mutations, getters }